<template>
  <div
    v-if="hasOptions"
    class="flex flex-col gap-200"
    data-containerid="product_options_configuration"
  >
    <EditorAddOnToggle v-for="{ name } in visibleAddOns" :key="name" v-bind="{ lotteryId, name }" />

    <EditorPrepaidSubscriptionToggle
      v-if="isPrepaidSubscriptionAllowed"
      ref="prepaidSubscriptionToggle"
      v-bind="{ lotteryId }"
    />

    <EditorTicketTypeToggle v-if="isSubscriptionAllowed" v-bind="{ lotteryId }" />
  </div>
</template>

<script lang="ts" setup>
import type { ComponentExposed } from 'vue-component-type-helpers'

import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

import type PrepaidSubscriptionToggle from './PrepaidSubscriptionToggle.vue'

type Props = {
  lotteryId: LotteryId
}

const { lotteryId } = defineProps<Props>()

const { isPrepaidSubscriptionAllowed, isSubscriptionAllowed, visibleAddOns } =
  useEditorOptions(lotteryId)

const prepaidSubscriptionToggle = useTemplateRef<
  ComponentExposed<typeof PrepaidSubscriptionToggle>
>('prepaidSubscriptionToggle')

const hasOptions = computed(
  () =>
    !!visibleAddOns.value.length ||
    isPrepaidSubscriptionAllowed.value ||
    isSubscriptionAllowed.value,
)

const validate = async () => (await prepaidSubscriptionToggle.value?.validate()) ?? true

defineExpose({ validate })
</script>
